let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("3KV1Y"), load("ffEVr"), load("2MuhG")]).then(() => parcelRequire('gelCt'));